<template>
<div v-if="isScanner">
  <div class="mb-4 header-menu flex" style="justify-content: flex-end">
    <p class="active">전체</p>
    <p>출근</p>
    <p>퇴근</p>
  </div>
  <ul class="table table-4 min-w100" style="border:1px solid #dedede;">
    <li>
      <span>구분</span>
      <span>이름</span>
      <span>날짜</span>
      <span>시간</span>
    </li>
    <li v-for="(item,index) in scannerTable.list" :key="index">
      <span>{{ item.location.location }}</span>
      <span>{{ item.user ? item.user.name : '' }}</span>
      <span>{{ new Date(item.created_at).format('yyyy-MM-dd') }}</span>
      <span>{{ new Date(item.created_at).format('HH:mm:ss') }}</span>
    </li>
  </ul>
  <div class="vs-con-table">
    <div class="con-pagination-table vs-table--pagination">
      <k-pagination
        :total="(scannerTable.lastPage) ? scannerTable.lastPage : 1"
        v-model="scannerTable.currentPage" @change="handleChangePage"></k-pagination>
    </div>
  </div>
</div>
<div v-else>
  <div class="mb-4 header-menu flex" style="justify-content: flex-end">
    <p class="active">전체</p>
    <p>출근</p>
    <p>퇴근</p>
  </div>
  <ul class="table table-3" style="border:1px solid #dedede;">
    <li>
      <span>구분</span>
      <span>날짜</span>
      <span>시간</span>
    </li>
    <li v-for="(item,index) in checkTable.list" :key="index">
      <span>{{ item.location.location }}</span>
      <span>{{ new Date(item.created_at).format('yyyy-MM-dd') }}</span>
      <span>{{ new Date(item.created_at).format('HH:mm:ss') }}</span>
    </li>
  </ul>
  <div class="vs-con-table">
    <div class="con-pagination-table vs-table--pagination">
      <k-pagination
        :total="(checkTable.lastPage) ? checkTable.lastPage : 1"
        v-model="checkTable.currentPage" @change="handleChangePage"></k-pagination>
    </div>
  </div>
</div>
</template>

<script>
import KPagination from '@/views/components/kPagination/kPagination'
export default {
  name: 'InputCheckLog',
  components: {KPagination},
  data () {
    return {
      checkTable:{
        list:[],
        perPage: 10,
        currentPage: 1,
        lastPage: 1
      },

      scannerTable:{
        list:[],
        perPage: 10,
        currentPage: 1,
        lastPage: 1
      }
    }
  },
  watch:{
    isScanner () {
      this.loadCheckLogList()
    }
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },
    isScanner () {
      return this.$store.state.auth.isScanner
    }
  },
  async mounted () {
    this.list = []

    const projectId = this.projectInfo.id
    if (projectId) {
      await this.$store.dispatch('IS_QR_SCAN_MANAGER', {projectId})
    }
    await this.loadCheckLogList()

  },

  methods:{
    async loadCheckLogList () {
      if (this.isScanner) {
        const projectId = this.$route.params.proj_id
        const page = this.scannerTable.currentPage
        const perPage = this.scannerTable.perPage
        // 내용불러오기
        await this.$store.dispatch('project/QR_HISTORY_SCANNER', {projectId, page, perPage})
        const qrCheckList = this.$store.state.project.qrHistoryScannerList
        this.scannerTable.lastPage = this.$store.state.project.qrHistoryScannerList.last_page
        this.scannerTable.list = qrCheckList.data
      } else {
        // 내용불러오기
        const projectId = this.$route.params.proj_id
        const page = this.checkTable.currentPage
        const perPage = this.checkTable.perPage

        await this.$store.dispatch('project/QR_HISTORY_ME', {projectId, page, perPage})
        const qrCheckList = this.$store.state.project.qrHistoryList
        this.checkTable.lastPage = this.$store.state.project.qrHistoryList.last_page
        this.checkTable.list = qrCheckList.data
      }
    },

    handleChangePage (_data) {
      this.currentPage = _data
      this.loadCheckLogList()
    }
  }
}
</script>

<style scoped>
.header-menu p {
  align-items: center;
  display: flex;
  color: #757575;

  padding:0 12px;
  border-right: 1px solid #cdcdcd;
  height:12px;

  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
}
.header-menu p:last-child {
  border-right: none;
}
.header-menu p.active {
  color: #1E0D61;
}

.table {
  background: #fff;
}
.table li:nth-child(2n) {
  background: #f9f9f9;
}
.table li span {
  border:none;
  font-weight: normal;
  font-size: 14px;
}
</style>
